
<template>
  <!--聊天账号管理-->
  <div>
    <x-tabula
      apiOrigin="PHP"
      ref="table"
      :dataSource="dataSource"
      rowKey="chat_user_id"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :rowSelection="false"
      :addHandleParam="addHandleParam"
      :deleteParam="deleteParam"
    >
      <template slot="opt_o" slot-scope="{row}">
        <img @click="showAvatar(row.avatar)" :style="{width: '30px', height: '30px'}" :src="row.avatar" alt="">
      </template>
    </x-tabula>

    <!--头像的弹窗-->
    <a-modal
      :visible="visible"
      @cancel="visible=false"
      v-bind="$store.state.modalDetailConfig"
      width="500px"
    >
      <div :style="{display: 'flex', justifyContent: 'center', alignItems: 'center'}">
        <img :src="userAvatar" alt="">
      </div>
    </a-modal>
  </div>
</template>

<script>
import { fetchSelect } from '../../../utils/mixins';
export default {
  mixins: [fetchSelect],
  name: 'chatAccount',
  data () {
    return {
      visible: false,
      userAvatar: '',
      cascadeParam: {},
      searchList: [
        { props: ['keywords'], placeholder: '用户昵称、手机号', options: [], inputType: 'input' },
        { props: ['user_type'], placeholder: '用户类型', options: this.$store.state.userTypeList, inputType: 'select' },
        { props: ['status'], placeholder: '状态', options: this.$store.state.chatStatusList, inputType: 'select' }
      ],
      searchParams: {
        keywords: undefined,
        user_type: undefined,
        status: undefined
      },
      tableOptList: [],
      rowOptList: [
        { text: '所在群聊', handle: record => this.toGroupChat(record), permi: ['neighbour:chatAccount:toGroup'] },
        { text: '封禁账号', handle: record => this.toAddBan(record), rowOptDisHandle: row => this.canBanAccount(row), permi: ['neighbour:chatAccount:ban'] }
      ],
      columns: [
        { title: 'memberID', dataIndex: 'uid', align: 'left', width: '' },
        { title: 'userID', dataIndex: 'chat_account', align: 'left', width: '' },
        { title: '用户昵称', dataIndex: 'nick_name', align: 'left', width: '' },
        { title: '手机号', dataIndex: 'mobile_phone', align: 'left', width: '' },
        { title: '用户类型', dataIndex: 'user_type_desc', align: 'left', width: '' },
        { title: '头像', dataIndex: 'avatar', align: 'left', width: '', scopedSlots: {customRender: 'o'} },
        { title: '状态', dataIndex: 'status_desc', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      listApi: {
        url: '/chat/user',
        resHandle: this.resHandle,
        searchHandle: '' // searchHandle
      },
      addHandleParam: {
        route: '',
        title: ''
      },
      deleteParam: {
        url: '',
        param: {pk_key: '', pk_val: ''},
        title: '',
        key: ''
      }
    };
  },
  created () {
    this.getSelect();
  },
  methods: {
    /* 获取下拉 */
    getSelect () {
      this._get({
        url: '/chat/group/selectlist',
        params: {}
      }).then(({data}) => {
        let index = this.gainListIndex(this.searchList, 'user_type');
        this.searchList[index].options = data.user_type;
      });
    },
    /** 判断封禁账号是否禁用 */
    canBanAccount (row) {
      return row.status === 0;
    },
    /** 查看头像 */
    showAvatar (avatar) {
      this.userAvatar = avatar;
      this.visible = true;
    },
    /** 进入群聊页面 */
    toGroupChat (record) {
      this.$router.push({
        name: 'groupChat',
        query: {
          id: record.chat_user_id,
          nick_name: record.nick_name,
          title: '查看用户所在群聊',
          breadNumber: 1
        }
      });
    },
    /** 进入添加封禁页面 */
    toAddBan (record) {
      this.$router.push({
        name: 'addBan',
        query: {
          mobile: record.mobile,
          userId: record.chat_user_id,
          complaintType: '1',
          route: 'chatAccount',
          title: '封禁账号'
        }
      });
    },
    resHandle (res) {
      res.forEach((el) => {
        if (el.status === 0) {
          el.status_desc = `${el.status_desc}（${el.end_time}）`;
        }
      });
      return res;
    },
    searchHandle (selectData) {
      console.log('处理搜索数据: ', selectData);
      return selectData;
    }
  }
};
</script>
